import { List } from 'immutable';
import { $getRoot } from 'lexical';
import { getTextStylesFromBrandStyle } from 'modules/BrandDefinition';
import * as Models from 'models';
import { $applyHorizontalAlignment } from './utils/horizontal-alignment';
import { $applyLineHeight } from './utils/line-height';

export function $applyBrandStyleForTextBlock(
  brandStyle: Models.BrandStyleMap | undefined,
): void {
  // colors and fonts have no effect on lineHeight, textAlign
  const textStyles = getTextStylesFromBrandStyle(brandStyle, List([]), List([]));
  const { lineHeight, textAlign } = textStyles;
  $getRoot().getChildren().forEach((node) => {
    $applyLineHeight(node, lineHeight);
    $applyHorizontalAlignment(node, textAlign);
  });
}
